// Berara utility bar — mobile benefit cycler.
// Auto-advances every 3s; arrow taps still work and reset the timer.
(function () {
  var INTERVAL_MS = 3000;

  document.querySelectorAll('[data-berara-benefit-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-berara-benefit-slide]');
    var prev = root.querySelector('[data-berara-benefit-prev]');
    var next = root.querySelector('[data-berara-benefit-next]');
    if (!slides.length || slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== index;
      });
    }

    function restart() {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(function () { show(index + 1); }, INTERVAL_MS);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1); restart(); });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      restart();
    }
  });
})();
